export default __webpack_public_path__ + "static/compareItemImg4-67438e742c23c80e53bc16e0c6cdb198.png";